import { EntityListResource } from '@witkac/kartamiejska-resources';
import { Dictionary, EntityModuleListState, Filter } from '@witkac/kartamiejska-shared';

import { AbstractModule } from './abstract.module';

export class EntityListModule<
  EntityType extends { id?: number },
  ResourceType extends EntityListResource<EntityType>
> extends AbstractModule<ResourceType> {
  /**
   * Stan modułu encji
   *
   * @type {EntityListModuleState<EntityType>}
   * @memberof EntityListModule
   */
  public state: EntityModuleListState<EntityType> = {
    list: [],
    count: 0
  };

  public mutations: Dictionary<(...args: any[]) => void> = {
    /**
     * Zapisuje listę do store
     *
     * @param localState stan lokalny
     * @param list lista encji
     */
    saveList(localState: EntityModuleListState<EntityType>, list: EntityType[]): void {
      localState.list = list;
    },
    /**
     * Zapisuje liczbę encji do store
     *
     * @param localState stan lokalny
     * @param count liczba encji
     */
    saveCount(localState: EntityModuleListState<EntityType>, count: any): void {
      localState.count = count;
    }
  };

  public actions: Dictionary<(...args: any[]) => Promise<void | any>> = {
    /**
     * Pobiera listę encji
     *
     * @param context context
     * @param filters filtry listy
     */
    list: async (context: any, filters: Filter): Promise<void> => {
      const { list, count } = await this.resource.list(filters);
      context.commit('saveList', list);
      context.commit('saveCount', count);
    }
  };
}
